import { authenticateWithSiteId } from '@wix/cli-auth';
import type { LoginMode } from '@wix/cli-core-definitions';
import { addUserFields } from '@wix/cli-telemetry';
import type { BiLogger } from '@wix/cli-telemetry';
import type { ErrorReporter } from '@wix/cli-error-reporting';

export async function authenticate({
  metaSiteId,
  biLogger,
  errorReporter,
  loginMode,
}: {
  metaSiteId: string;
  biLogger: BiLogger;
  errorReporter: ErrorReporter;
  loginMode?: LoginMode;
}) {
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  const authState = await authenticateWithSiteId(
    metaSiteId,
    biLogger,
    errorReporter,
    loginMode
  );
  errorReporter.setUser({ id: authState.userInfo.userId });
  addUserFields(biLogger, authState.userInfo.userId);

  return authState;
}
